import React, { FC, useEffect } from 'react';
import { ScheduledSurgeTabType, SurgeTabType } from './types';

type Props = {
  active: SurgeTabType | ScheduledSurgeTabType;
  setActive: (arg1: any) => void;
  list: SurgeTabType[] | ScheduledSurgeTabType[];
  defaultActiveTab?: SurgeTabType | ScheduledSurgeTabType;
};

const SurgeTabs: FC<Props> = ({ list, active, setActive, defaultActiveTab }) => {
  useEffect(() => {
    setActive(defaultActiveTab ?? list?.[0]);
  }, []);
  const styles = {
    active: 'bg-[#FFFFFF] border border-[#F2F2F2] shadow-md rounded py-[5px]  px-5 transition',
    inactive: 'bg-[#F5F5F5] text-[#858585] rounded border-none py-[5px] px-5 transition '
  };

  return (
    <div className='flex md:w-full max-md:flex-col max-md:gap-2 justify-between  rounded bg-[#F5F5F5] py-[4px] font-medium text-xs px-[6px]'>
      {list?.map((name) => (
        <button
          key={name}
          onClick={() => setActive(name)}
          className={`${active === name ? styles.active : styles.inactive}`}>
          {name}
        </button>
      ))}
    </div>
  );
};

export default SurgeTabs;
